"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Spinner_1 = __importDefault(require("../../../common/Spinner/Spinner"));
var Toast_1 = require("../../../common/Toast");
var localStorage_1 = __importDefault(require("../../../config/localStorage"));
var org_hook_1 = require("../../../context/OrgContext/org.hook");
var general_1 = require("../../../lib/general");
var HeaderBar_1 = __importDefault(require("../../../theme/headerbar/HeaderBar"));
var AddDiseaseForm_1 = __importDefault(require("./AddDiseaseForm"));
var DiseaseCard_1 = __importDefault(require("./DiseaseCard"));
var Mutation_1 = require("./Graphql/Mutation");
var Queries_1 = require("./Graphql/Queries");
require("./Style/style.scss");
function Knowledge() {
    // const { disease } = useDis();
    var _this = this;
    var _a, _b;
    var _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n, organization = (0, org_hook_1.useOrg)().organization, getCurrentLang = i18n.language, 
    // [clickStatus, setClickStatus] = useState(false),
    _d = (0, react_1.useState)({
        en: "",
        fr: "",
        rn: "",
    }), languages = _d[0], setLanguages = _d[1], 
    // [editDiseaseParam, setEditDiseaseParam] = useState(null),
    _e = (0, react_1.useState)(null), success = _e[0], setSuccess = _e[1], _f = (0, react_1.useState)(false), loading = _f[0], setLoading = _f[1], _g = (0, client_1.useMutation)(Mutation_1.UPSERT_DISEASE, {
        fetchPolicy: "network-only",
        refetchQueries: [Queries_1.GET_DISEASES, "getDiseasesList"],
    }), upsertDisease = _g[0], upsertDiseaseResponse = _g[1], _h = (0, client_1.useLazyQuery)(Queries_1.GET_DISEASES, {
        variables: { organization_id: organization.id },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onCompleted: function () {
            setLoading(false);
        },
        onError: function () {
            setLoading(false);
        },
    }), getDiseasesList = _h[0], getResponse = _h[1], _j = (0, client_1.useMutation)(Mutation_1.DELETE_DISEASE, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        refetchQueries: [Queries_1.GET_DISEASES, "getDiseasesList"],
    }), deleteDisease = _j[0], deleteDiseaseResponse = _j[1];
    (0, react_1.useEffect)(function () {
        getDiseasesList();
        getLanguages();
    }, []);
    (0, react_1.useEffect)(function () {
        if (success) {
            var timer_1 = setTimeout(function () {
                setSuccess(null);
            }, 5000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [success]);
    var //  reformatDiseaseParam = () => {
    //     const reformat: any = {
    //       id: null,
    //       title: JSON.stringify(languages),
    //       category: null,
    //       // description: JSON.stringify(languages),
    //       // version: [],
    //       // icon: null,
    //       thumbnail: languages,
    //       video: languages,
    //       // versionsId: [],
    //       sorting_order: null,
    //       organization_id: organization.id,
    //     };
    //     setEditDiseaseParam(reformat);
    //   },
    getLanguages = function () { return __awaiter(_this, void 0, void 0, function () {
        var data, tmp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem("languages")];
                case 1:
                    data = _a.sent(), tmp = {};
                    data.map(function (l) {
                        return Object.entries(l).map(function (_a) {
                            var _b;
                            var key = _a[0], value = _a[1];
                            if (key === "value") {
                                Object.assign(tmp, (_b = {}, _b[value] = "", _b));
                            }
                        });
                    });
                    setLanguages(tmp);
                    return [2 /*return*/];
            }
        });
    }); }, onSavePressed = function (data) {
        window.scrollTo(0, 0);
        var variables = {
            id: data[0].id,
            name: data[0].name,
            disease_type_id: null,
            organization_id: organization.id,
            sorting_order: data[0].sorting_order,
            icon: data[0].icon,
            scientific_name: data[0].scientific_name,
            published: true,
        };
        upsertDisease({
            variables: variables,
        });
    }, 
    // getVal = (obj: { [x: string]: any }) => {
    //   const tmp: any = [];
    //   Object.keys(obj).forEach((key) => {
    //     const lang = key,
    //       name = obj[key] === "" ? null : obj[key];
    //     tmp.push({
    //       lang,
    //       name,
    //     });
    //   });
    //   return tmp;
    // },
    // saveDisease = (formData: any) => {
    //   window.scrollTo(0, 0);
    //   setLoading(true);
    //   const thumbnailArr = getVal(formData.thumbnail),
    //     videoArr = getVal(formData.video),
    //     check_category =
    //       typeof formData.category === "object" && formData.category !== null
    //         ? formData.category.value
    //         : formData.category,
    //     variables = {
    //       title: formData.title,
    //       published: true,
    //       sorting: null,
    //       disease_id: disease.id,
    //       disease_info_category_id: check_category,
    //       // version: formData.versionsId,
    //       disease_media: {
    //         // icon: formData.icon,
    //         thumbnail: thumbnailArr,
    //         video: videoArr,
    //       },
    //       // description: formData.description,
    //       disease_info_details_id: formData.id,
    //       sorting_order: formData.sorting_order,
    //       organization_id: organization.id,
    //     };
    // },
    // ondiseaseedit = (params: any) => {
    //   window.scrollTo(0, 0);
    //   const reformat: any = {
    //     id: params.id,
    //     title: params.title,
    //     category: params.disease_info_category_id,
    //     thumbnail: languages,
    //     video: languages,
    //     sorting_order: 1,
    //     organization_id: organization.id,
    //   };
    //   setEditDiseaseParam(reformat);
    // },
    ondiseasedelete = function (params) {
        // Window.scrollTo(0, 0);
        deleteDisease({
            variables: {
                id: params.id,
                organization_id: organization.id,
                // disease_info_category_id: params.disease_info_category_id,
            },
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loading && react_1.default.createElement(Spinner_1.default, null),
        ((deleteDiseaseResponse === null || deleteDiseaseResponse === void 0 ? void 0 : deleteDiseaseResponse.loading) || (upsertDiseaseResponse === null || upsertDiseaseResponse === void 0 ? void 0 : upsertDiseaseResponse.loading)) && (react_1.default.createElement(Spinner_1.default, null)),
        (((_a = upsertDiseaseResponse === null || upsertDiseaseResponse === void 0 ? void 0 : upsertDiseaseResponse.data) === null || _a === void 0 ? void 0 : _a.upsertDisease) || success) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t(((_b = upsertDiseaseResponse === null || upsertDiseaseResponse === void 0 ? void 0 : upsertDiseaseResponse.data) === null || _b === void 0 ? void 0 : _b.upsertDisease) || success), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        (deleteDiseaseResponse === null || deleteDiseaseResponse === void 0 ? void 0 : deleteDiseaseResponse.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t("deleted successfully"), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        react_1.default.createElement(HeaderBar_1.default
        // onSave={() => setClickStatus(true)}
        , { 
            // onSave={() => setClickStatus(true)}
            title: (0, general_1.isJsonWithAvailableLang)("diseases", getCurrentLang, t) },
            react_1.default.createElement(AddDiseaseForm_1.default, { getDiseasesList: getDiseasesList, getResponse: getResponse, isSuccess: upsertDiseaseResponse === null || upsertDiseaseResponse === void 0 ? void 0 : upsertDiseaseResponse.data, languages: languages, list: (getResponse === null || getResponse === void 0 ? void 0 : getResponse.data) ? getResponse.data.getDiseasesList : [], onSaveClick: function (data) { return onSavePressed(data); }, ondiseasedelete: function (data) { return ondiseasedelete(data); } }),
            react_1.default.createElement(DiseaseCard_1.default, null))));
}
exports.default = Knowledge;
